// Shared frontend helpers for leads.
export const STAGES = ["DNP", "Followup", "Meeting Scheduled", "Send Proposal", "Onboarded", "Rejected"];
export const TERMINAL_STAGES = new Set(["DNP", "Rejected"]);
export const CATEGORIES = ["Ace", "King", "Queen", "Joker"];

export const CATEGORY_COLORS = {
  Ace: { bg: "var(--brand-primary)", fg: "#fff", border: "var(--brand-primary)" },
  King: { bg: "var(--brand-champagne)", fg: "var(--brand-ink)", border: "var(--brand-champagne)" },
  Queen: { bg: "var(--brand-border)", fg: "var(--brand-ink)", border: "var(--brand-border-soft)" },
  Joker: { bg: "transparent", fg: "var(--brand-muted)", border: "var(--brand-border-soft)" },
};

// 3px left rule on Kanban cards keyed by category — per Phase 2 spec
export const CATEGORY_LEFT_RULE = {
  Ace: "var(--brand-primary)",     // teal
  King: "#1e3a8a",    // ink blue
  Queen: "#92400e",   // amber
  Joker: "#7f1d1d",   // dim red
};

export const CATEGORY_RANK = { Ace: 0, King: 1, Queen: 2, Joker: 3 };

export const STAGE_COLORS = {
  DNP: "var(--brand-muted)",
  Followup: "var(--brand-primary)",
  "Meeting Scheduled": "#7c6492",
  "Send Proposal": "var(--brand-champagne)",
  Onboarded: "var(--brand-success)",
  Rejected: "var(--brand-danger)",
};

export const BUCKET_COLORS = {
  overdue: "var(--brand-danger)",
  due_today: "var(--brand-muted)",
  upcoming: "var(--brand-primary)",
  none: "var(--brand-muted)",
};

export function relTime(iso) {
  if (!iso) return "";
  const dt = new Date(iso);
  const diff = (Date.now() - dt.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return dt.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

export function fmtINR(v) {
  if (v == null || v === "") return "—";
  return "₹" + Number(v).toLocaleString("en-IN");
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return iso;
  return dt.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}
